var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.3125C19.0029 16.3125 22.6562 12.6592 22.6562 8.15625C22.6562 3.65332 19.0029 0 14.5 0C9.99707 0 6.34375 3.65332 6.34375 8.15625C6.34375 12.6592 9.99707 16.3125 14.5 16.3125ZM21.75 18.125H18.6291C17.3717 18.7027 15.9727 19.0312 14.5 19.0312C13.0273 19.0312 11.634 18.7027 10.3709 18.125H7.25C3.24551 18.125 0 21.3705 0 25.375V26.2812C0 27.7822 1.21777 29 2.71875 29H26.2812C27.7822 29 29 27.7822 29 26.2812V25.375C29 21.3705 25.7545 18.125 21.75 18.125Z",
    fill: "#3E8181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutme);
export default __webpack_public_path__ + "static/media/Aboutme.9acca9a056c69468e00744d51e4d2823.svg";
export { ForwardRef as ReactComponent };